




























import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import RadioName from '@/product/components/RadioName.vue'
import { ProductEditPattern } from '@/product/types'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'

export default Vue.extend({
  components: { BaseImage, RadioName },
  props: {
    option: {
      type: Object as () => ProductEditPattern,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imagePlaceholder() {
      return SVG_PLACEHOLDER_IMAGES.EDIT_PATTERN_IMAGE
    }
  },
  methods: {
    onSelectEditPattern(option: ProductEditPattern) {
      this.$emit('update', option)
    }
  }
})
